module.exports = __webpack_public_path__ + "static/cookie3-60c20e37f60cb808cc424cd8c531d4b3.png";